<div class="rate-accordion-card flex justify-content-between">
  <span class="rate-accordion-card__text ta-center">{{ ratesItem.serviceName | titlecase }}</span>
  <span> ${{ ratesItem.serviceRate }} / {{ ratesItem.rateFrequency }}</span>
</div>
